var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A9B9CB;}\n\t.st1{fill:#7F8B99;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M412.2,174.8c0-6.1-1.3-11.6-4-16.2c-2.6-4.6-6.5-8.4-11.7-11.4 c-43.2-24.9-86.4-49.8-129.6-74.7c-11.6-6.7-22.9-6.5-34.5,0.3c-17.2,10.1-103.3,59.5-128.9,74.4c-10.6,6.1-15.7,15.5-15.7,27.7 c0,50.1,0,100.3,0,150.4c0,6,1.3,11.3,3.8,15.9c2.6,4.7,6.6,8.7,11.9,11.8c25.7,14.9,111.7,64.2,128.9,74.4 c11.6,6.8,22.8,7.1,34.5,0.3c43.2-25,86.4-49.8,129.6-74.7c5.4-3.1,9.3-7,11.9-11.8c2.5-4.6,3.8-9.9,3.8-15.9 C412.2,325.2,412.2,224.9,412.2,174.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M266.6,72.7c-11.6-6.7-22.9-6.5-34.4,0.3c-17.2,10.1-103.1,59.4-128.7,74.2 c-10.5,6.1-15.7,15.4-15.7,27.6c0,50,0,100,0,150c0,6,1.3,11.3,3.8,15.9c2.6,4.7,6.6,8.6,11.9,11.7c5.9,3.4,14.9,8.6,25.5,14.7 l237.1-237.1C332.9,111,299.8,91.9,266.6,72.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st2",
    d: "M283.5,227.1l50.5,0.4c0-21-21.3-72.6-82.3-72.6c-38.9,0-91.2,24.7-91.2,95.8 c0,71.1,51.3,94.3,91.2,94.3c64.7,0,80.1-44.7,80.1-70l-48.2-2.8c0,0,1.3,29.2-32.2,29.2c-30.9,0-36.1-37.9-36.1-50.7 c0-19.6,7-51,36.1-51C280.5,199.8,283.5,227.1,283.5,227.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/c_logo.06a7aa15451c5da63b9e5eddd4365598.svg";
export { ForwardRef as ReactComponent };